<template>
    <div class="finish">
        <div class="d-flex justify-content-center align-items-center title text-primary">
            <b-icon-check2-circle class="mr-1 icon" /> 您已成功預約諮詢
        </div>
        <p class="d-flex justify-content-center text mt-2">謝謝您，我們將會立即與您聯繫，或查詢您的預約進度。</p>
        <img src="../assets/images/finish.png"
             class="img"
             alt="預約完成" />

        <div class="d-flex flex-row px-4 justify-content-around align-items-center my-5">
            <b-button pill
                      variant="outline-primary"
                      class="button spacing"
                      :data-ga-element="`新保險網站_${newFriend?'新業務':'原業務'}預約完成_查預約`"
                      v-on:click="goReview">查預約</b-button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'FinishForShare',
    created() {
        this.$store.dispatch('setSubHeaderShow', false);
        this.$store.dispatch('setHasContent', false);
    },
    computed: {
        newFriend() {
            return this.$store.state.newFriend;
        },
    },
    methods: {
        goHome() {
            const protocol = window.location.protocol;
            const host = window.location.host;

            window.location.href = `${protocol}//${host}/fubonagent/`;
        },
        goReview() {
            const protocol = window.location.protocol;
            const host = window.location.host;
            window.location.href = `${protocol}//${host}/fubonagent/followupForShare`;
        }
    },
};
</script>

<style scoped lang="scss">
.finish {
    padding: 15px;
}
.title {
    font-size: 30px;
    padding-top: 25px;
}
.icon {
    font-size: 35px;
}
.text {
    color: #666;
}
.img {
    width: 100%;
}
</style>
